"use client"
import Card from "@/components/atoms/Card";
import HeadingWithBullets from "@/revamp/organisms/HeadingWithBullets/HeadingWithBullets";
import styles from "@/revamp/organisms/CourseCurriculum/CourseCurriculum.module.scss";
import cn from "clsx";
import Markdown from "@/components/atoms/Markdown";
import { ModalTypes } from "@/types/modal";
import CommonButton from "@/components/common/Analytics/CustomButton";
import ClientSideButton from "@/revamp/organisms/CourseCurriculum/ClientSideButton";
import DegreeSection from "@/revamp/organisms/CourseCurriculum/CourseSection";

export default function CourseCurriculumLandingPageMBA({
  CourseCurriculum,
  DegreeOfferedByUs,
  isCard = true,
  isCampusImmersionPage = false,
  associatedPrograms = [],
  isLambdaApi,
  Custom10PgType,
  specializationText,
  LandingPageBrochure,
  isSpecificPage,
  isRFIDisabled = false,
  CertificateOfferedByUs,
  isNextGen=false,
  ObserverShip
}: {
  CourseCurriculum: any;
  DegreeOfferedByUs: any;
  isCard?: boolean;
  isCampusImmersionPage?: boolean
  associatedPrograms?: Array<ProgramDetails>,
  isLambdaApi?: boolean,
  Custom10PgType?: string,
  specializationText?: string,
  LandingPageBrochure?: any,
  isSpecificPage?:boolean,
  isRFIDisabled?: boolean;
  isNextGen?:boolean;
  CertificateOfferedByUs?:CertificateOffered
  ObserverShip?:ObserverShip
}) {
  if (!CourseCurriculum?.enabled && !DegreeOfferedByUs?.enabled) return null;

  const courseCurriculumTitle = CourseCurriculum?.Title?.text?.replace(/\n/gi, "  \n");
  const brochure =LandingPageBrochure?.data?.attributes?.url
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
  return (
    <div
      className={cn("container",    isCampusImmersionPage && styles.CourseCurriculum__section,
        { [styles.marginTopZero]: isCampusImmersionPage ,"mt-4":isLambdaApi}
     )}
    >
      <Card noXPadding={true} shadow={false}>
        <div className={cn(styles.CourseCurriculum__cardContainer)}>
          {CourseCurriculum?.enabled ? (
            <div id={`${Object.keys({CourseCurriculum})}`} className={cn(styles.CourseCurriculum__container)}>
              <div className={cn(styles.CourseCurriculum__textContainer)}>
                {CourseCurriculum?.Title?.enabled && (
                  <h3
                  id={`${Object.keys({CourseCurriculum})}-heading`}
                    className={cn(
                      { [styles.CourseCurriculum__title] : !isCampusImmersionPage},
                      "text-primary-blue",
                      "font-baskervville",
                      { [styles.campusImmersion]: isCampusImmersionPage }
                    )}
                  >
                    <Markdown>
                      {courseCurriculumTitle} 
                    </Markdown>
                  </h3>
                )}
                {!isCampusImmersionPage && CourseCurriculum?.CTA?.enabled && !isRFIDisabled && (
                  <div className={cn(styles.CourseCurriculum__cta, "shrink-0")}>
                    {(!isLambdaApi || (isLambdaApi && brochure)) &&  <CommonButton
                    id = "courseCurriculum-cta"
                      onClickStorePayload={
                        {
                          sectionTitle : courseCurriculumTitle,
                          parentSection : courseCurriculumTitle
                        }
                      }
                      GADataNew={{
                        event :"lead_initiates",
                        cta_text: CourseCurriculum?.CTA?.text,
                        section_name: courseCurriculumTitle,
                        header_title: courseCurriculumTitle || "NA",
                        isPageType : true,
                        page_url : true
                      }}
                      type={"button"}
                      modalType={ModalTypes.DownloadBrochureLP}
                      modalData={{ specializationText, Custom10PgType, programDetails,brochure }}
                      className={cn(styles.ctaBtn, "whitespace-nowrap")}
                      hoverIcon="/_a/icons/arrow-down-white.svg"
                      icon="/_a/icons/arrow-down-white.svg"
                      bg={"bl"}
                      color={"o"}
                      webEngageEvent={{eventName: "Download Brochure Clicked" }}
                    >
                      {CourseCurriculum?.CTA?.text.toUpperCase()==='DOWNLOAD BROCHURE'?'EXPLORE CURRICULUM':CourseCurriculum?.CTA?.text}
                    </CommonButton> }
                  </div>
                )}
                {isCampusImmersionPage && <div><ClientSideButton associatedPrograms={associatedPrograms}/></div>}
              </div>
              <hr
                className={cn(
                  "text-[#D4D4D4]",
                  styles.CourseCurriculum__border
                )}
              />
              <div>
                <HeadingWithBullets  courseCurriculumTitle={courseCurriculumTitle}  data={CourseCurriculum?.PerSemCurriculum} />
              </div>
            </div>
          ) : null}
      
          {DegreeOfferedByUs?.enabled ? (
            <div  id={`${Object.keys({DegreeOfferedByUs})}`}>
                 <DegreeSection isLambdaApi={isLambdaApi}  DegreeOfferedByUs={DegreeOfferedByUs}
          CertificateOfferedByUs={CertificateOfferedByUs}
          ObserverShip={ObserverShip}/>
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
}
